import { render } from "./BookingForm.vue?vue&type=template&id=d62e4580&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"

import "./BookingForm.vue?vue&type=style&index=0&id=d62e4580&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d62e4580"

export default script